import { Context, createContext, useContext } from 'react';

import {
  findTabByIdString,
  getTabByIdString,
} from '~/scenes/PortalViews/Views/EmployeeViews/Modules/components/EmployeeModuleTabs/data';

type EmployeeModuleTabContextProps = {
  activeTab: string | undefined;
  previousTab: string | undefined;
  setActiveTab: (tab: string) => void;
};

export const EmployeeModuleTabContext: Context<EmployeeModuleTabContextProps> =
  createContext<EmployeeModuleTabContextProps>({
    activeTab: undefined,
    previousTab: undefined,
    setActiveTab: (_tab: string) => {},
  });

type UseEmployeeModuleTabContextOutput<TabPath> = {
  activeTab: TabPath;
  previousTab: TabPath | undefined;
  setActiveTab: (tab: TabPath) => void;
};

type PropsType<TabPath> = {
  defaultTab: TabPath;
  enabledTabPaths: TabPath[];
};

export const useEmployeeModuleTabContext = <TabPath>(
  props: PropsType<TabPath>,
): UseEmployeeModuleTabContextOutput<TabPath> => {
  const { defaultTab, enabledTabPaths } = props;

  const tabContext = useContext<EmployeeModuleTabContextProps>(
    EmployeeModuleTabContext,
  );

  const activeTab = tabContext.activeTab
    ? getTabByIdString(tabContext.activeTab, enabledTabPaths, defaultTab)
    : defaultTab;
  const previousTab = tabContext.previousTab
    ? findTabByIdString(tabContext.previousTab, enabledTabPaths)
    : undefined;

  return {
    activeTab,
    previousTab,
    setActiveTab: (tab: TabPath) => tabContext.setActiveTab(`${tab}`),
  };
};
